import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class AnnualAverageService {

  private api_url = CONFIGURATION.baseServiceUrl + 'annual-average-pay-day/';
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

  constructor(private _http: Http) { }

  listofControlGroups(){
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.api_url + 'reference-data', {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  tableData(oData:any) :Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'report-data',oData, {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  getCount(oData:any) :Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'report-count',oData, {headers:headers})
    .map((response: Response) => response.json())
    .catch(this.handleError);
  }
  downloadExcel(oData:any) :Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'excel-download', oData, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          const blob = new Blob([res.blob()], { type: 'application/zip' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl);
      })
  }
  downloadPdf(oData:any) :Observable<any>{
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.api_url + 'pdf-download', oData, { headers: headers, responseType: ResponseContentType.Blob }).map(
      (res) => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          const blob = new Blob([res.blob()], { type: 'application/zip' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl);
      })
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

  getSSnData(ssnData: any): Observable<any[]> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
        + '&TaxYear=' + ssnData.taxyear
        + '&ControlGroup=' + ssnData.controlgroup
        + '&ReportName=' + 'PayDayAnnualAverageReport';
    return this._http.get(this._ssnUrl + fileName, { headers: headers })
        .map((response: Response) => response.json())
        .catch(this.handleError);
}

}



// WEBPACK FOOTER //
// ./src/app/annual-average/annual-average.service.ts